import e from "react";
function t(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function r(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function n(e) {
  return (n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function o(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {},
      o = Object.keys(n);
    "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
      return Object.getOwnPropertyDescriptor(n, e).enumerable;
    }))), o.forEach(function (t) {
      r(e, t, n[t]);
    });
  }
  return e;
}
function c(e, t) {
  return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : function (e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      r.push.apply(r, n);
    }
    return r;
  }(Object(t)).forEach(function (r) {
    Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
  }), e;
}
function i(e, t) {
  return (i = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var a = function a(t) {
    return e.createElement("span", {
      className: "arrow-container",
      style: t.outerStyle
    }, e.createElement("span", {
      className: "arrow",
      style: {
        borderWidth: t.size
      }
    }));
  },
  u = function u(t) {
    var r = t.size + t.arrowOffset,
      n = {
        outerStyle: {
          height: t.size,
          width: 2 * t.size + 10,
          left: {
            left: -r,
            right: "calc(100% - ".concat(r, "px)"),
            center: "calc(50% - ".concat(r, "px)")
          }[t.alignment],
          top: "up" === t.direction ? "100%" : -t.size - t.borderWidth
        }
      };
    return e.createElement(a, c(o({}, n), {
      size: t.size
    }));
  },
  s = function s(t) {
    var r = t.size + t.arrowOffset,
      n = {
        outerStyle: {
          width: t.size + t.borderWidth + 10,
          height: 2 * t.size + 10,
          left: "left" === t.direction ? "calc(100% - ".concat(10, "px") : -t.size,
          top: {
            top: -r,
            bottom: "calc(100% - ".concat(r, "px)"),
            center: "calc(50% - ".concat(r, "px)")
          }[t.alignment]
        }
      };
    return e.createElement(a, c(o({}, n), {
      size: t.size
    }));
  },
  f = function (r) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && i(e, t);
    }(p, r);
    var c,
      a,
      f,
      l = (c = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
          t,
          r = n(p);
        if (c) {
          var o = n(this).constructor;
          t = Reflect.construct(r, arguments, o);
        } else t = r.apply(this, arguments);
        return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : function (e) {
          if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(this);
      });
    function p() {
      return !function (e, t) {
        if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
      }(this, p), l.apply(this, arguments);
    }
    return a = [{
      key: "render",
      value: function value() {
        switch (this.props.direction) {
          case "up":
          case "down":
            return e.createElement(u, o({}, this.props, this.state));
          case "left":
          case "right":
            return e.createElement(s, o({}, this.props, this.state));
          default:
            throw "invalid direction " + this.props.direction;
        }
      }
    }], t(p.prototype, a), f && t(p, f), p;
  }(e.Component);
r(f, "displayName", "PopoverArrow");
export { f as PopoverArrow };